import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import { DurationSelector } from "../durationSelector";
import { EngineSelector } from "../engineSelector";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";

export const DisplayController = (props) => {
  const { vesselId, currentVessel, selectedEngine, setSelectedEngine, selectedGraph, } = props;
  return (
    <Grid container spacing={1} direction="row">
      <Grid item size={{sm:8, md:8}}>
        <DurationSelector vesselId={vesselId} currentVessel={currentVessel} selectedEngine={selectedEngine} selectedGraph={selectedGraph} />
      </Grid>
      {selectedGraph === GRAPH_TYPE.ENGINE && (
        <Grid item size={{sm: 4, md:4}} sx={{display: 'flex', alignItems: 'flex-end'}}>
          <EngineSelector currentVessel={currentVessel} selectedEngine={selectedEngine} setSelectedEngine={setSelectedEngine} />
        </Grid>
      )}
    </Grid>
  );
};

DisplayController.propTypes = {
  vesselId: PropTypes.string,
  currentVessel: PropTypes.object,
  selectedEngine: PropTypes.string,
  setSelectedEngine: PropTypes.func,
  selectedGraph: PropTypes.string,
}